import { render } from '@testing-library/react';
import { IntlProvider } from 'react-intl';
import { MemoryRouter } from 'react-router-dom';
// import { ThemeProvider } from 'styled-components';
// import theme from 'styles/theme';

export const renderWithTheme = () =>
  render(
    <IntlProvider locale="en-US" onError={() => undefined}>
      <MemoryRouter>
        {/* <ThemeProvider theme={theme as any}>{children}</ThemeProvider> */}
      </MemoryRouter>
    </IntlProvider>,
  );
